import { render, staticRenderFns } from "./LbsReal.vue?vue&type=template&id=2b5322bf&scoped=true"
import script from "./LbsReal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LbsReal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LbsReal.vue?vue&type=style&index=0&id=2b5322bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5322bf",
  null
  
)

export default component.exports